const content: { [key: string]: any } = {
  copyright: 'Alticor Inc.',
  confidential:
    'Confidential. Contains Amway Information. Use only as permitted by contract with Amway.',
  adminOnlyLabel: 'For Administrator Use Only. Not for prospect use.',
};

export default content;
